export const DATA_TYPE = {
    Number: 'number',
    String: 'string',
    Boolean: 'boolean',
    Enum: 'enum',
    Object: 'object',
    Array: 'array',
    Date: 'date',
}